import { handleActions } from "redux-actions";
import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom,
  getThisYear
} from "../../../../../../utils/date-range-options";
import {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  SET_FILTERS_DIRTY,
  SET_DATES,
  UPDATE_DATES,
  UPDATE_FILTERS_SUCCESS,
  FETCH_CHART_SUCCESS,
  UPDATE_GROUP_CATEGORY,
  SET_UPDATES_LOADING,
  RESET_FILTER_SELECTED,
  UPDATE_SHOW_NET_REVENUE_SELECTED,
  UPDATE_SHOW_EXPENSES_SELECTED,
  UPDATE_PERIOD_TYPE,
  UPDATE_TABLE_VIEW_SELECTED,
  UPDATE_CUSTOM_RANGE
} from "../sagas/totalRevenueSales/totalRevenueSales";

export const initialState = {
  currentUser: {},
  chartData: {},
  isLoading: true,
  updatesLoading: false,
  filtersDirty: false,
  selectedRequestDates: {},
  datesDirty: false,
  filters: {
    period_type: "monthly",
    include_returns: false,
    show_expenses: false,
    net_revenue_toggle_name: "",
    primary_categories: [],
    toggles: {}
  },
  selectedFilters: {
    period_type: "Monthly",
    table_view: false,
    include_returns: false,
    show_expenses: false,
    group_categories: 1
  },
  periodTypeOptions: ["Daily", "Weekly", "Monthly", "Quarterly", "Yearly"],
  selectedRangeOption: {
    id: 1,
    name: getThisYear(undefined, true)
  },
  rangeOptions: getRangeOptions(undefined, true)
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_DATES]: (state, action) => {
      const rangeOptions = getRangeOptions(
        action.payload.endDate,
        state.currentUser.calendarStartDate
      );
      return {
        ...state,
        selectedRequestDates: action.payload || state.selectedRequestDates,
        rangeOptions: getRangeOptionsWithCustom(rangeOptions, action),
        selectedRangeOption: getSelectedRangeOptionWithCustom(action)
      };
    },
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      filtersDirty: true,
      datesDirty: true
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true,
      datesDirty: true,
      selectedFilters: {
        ...state.selectedFilters
      }
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload.currentUser || state.currentUser
    }),
    [FETCH_CHART_SUCCESS]: (state, action) => ({
      ...state,
      chartData: action.payload || state.chartData
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: action.payload || state.filters
    }),
    [UPDATE_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: action.payload
    }),
    [RESET_FILTER_SELECTED]: (state) => ({
      ...state,
      filtersDirty: false,
      datesDirty: false,
      selectedFilters: {
        ...initialState.selectedFilters
      }
    }),
    [UPDATE_GROUP_CATEGORY]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        group_categories: action.payload ? 1 : 2
      }
    }),
    [UPDATE_SHOW_NET_REVENUE_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        include_returns: action.payload
      }
    }),
    [UPDATE_SHOW_EXPENSES_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        show_expenses: action.payload
      }
    }),
    [UPDATE_PERIOD_TYPE]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        period_type: action.payload
      }
    }),
    [UPDATE_TABLE_VIEW_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        table_view: action.payload
      }
    })
  },
  initialState
);
